"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNC_DELAY = exports.BLINK_PERIOD = void 0;
exports.BLINK_PERIOD = 1000; // ms
exports.SYNC_DELAY = `-${Date.now() % exports.BLINK_PERIOD}ms`;
//# sourceMappingURL=blink.js.map